import { FC, ButtonHTMLAttributes } from 'react'

import styled from 'styled-components'

import QuestionIcon from 'src/Assets/Svg/pages-icons/QuestionButton.svg?react'

const Button = styled.button`
  display: flex;
  justify-content: center;
  padding: 0;
  align-items: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.color.lightGrey};
  border: none;
  outline: none;
  cursor: pointer;
  transition:
    transform 0.2s ease-in-out,
    background-color 0.2s ease-in-out;

  svg path {
    fill: ${({ theme }) => theme.color.darkGrey};
  }

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.color.white};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.brandGreen};
    background-color: ${({ theme }) => theme.color.white};
    transform: none;
  }

  &:active:not(:disabled) {
    svg path {
      fill: ${({ theme }) => theme.color.mediumGrey};
    }
  }

  &:disabled {
    background-color: ${({ theme }) => theme.color.white};
    cursor: not-allowed;
    opacity: 0.5;
    svg path {
      fill: ${({ theme }) => theme.color.slateGrey};
    }
  }
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .QuestionIcon {
    width: 6px;
    height: 10px;
  }
`

export const QuestionButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  disabled,
  ...restProps
}) => (
  <Button data-testid='question-button' disabled={disabled} {...restProps}>
    <IconWrapper>
      <QuestionIcon className='QuestionIcon' />
    </IconWrapper>
  </Button>
)
